
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success",
      function () {
        return require("private-next-pages/success/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success"])
      });
    }
  